"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateIssuePermissionItemAction = exports.reducer = exports.getNewPermissionIds = exports.getIssuePermissions = exports.getIsLoadingIssuePermissions = exports.fetchIssuePermissionsAction = exports.deleteIssuePermissionAction = exports.batchCreateIssuePermissionsAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _sdk = require("../../../../sdk");
var _fetchHelpers = require("../fetchHelpers");
var _noop = _interopRequireDefault(require("lodash/noop"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const initialState = {
  ..._fetchHelpers.initialEntityCollectionState,
  newEntityIds: []
};
const issuePermissionsSlice = (0, _toolkit.createSlice)({
  name: "permissions",
  reducers: {
    permissionsFetchStartAction: state => (0, _fetchHelpers.fetchStartReducer)(state),
    permissionsFetchSuccessAction: (state, action) => (0, _fetchHelpers.fetchSuccessReducer)(state, action),
    permissionsFetchErrorAction: state => (0, _fetchHelpers.erroredReducer)(state),
    permissionsBatchCreateSuccessAction: (state, action) => {
      state.orderedIds.push(...state.newEntityIds);
      state.newEntityIds = [];
      for (const resource of action.payload) {
        state.newEntityIds.push(resource.id);
        state.entitiesMap[resource.id] = {
          ...resource,
          permittedAttributes: ["permissionLevel"],
          permittedActions: [_sdk.PermittedAction.CanEdit, _sdk.PermittedAction.Delete]
        };
      }
    },
    permissionUpdateStartAction: (state, action) => {
      state.pendingUpdatesMap[action.payload.id] = {
        permissionLevel: action.payload.permissionLevel
      };
    },
    permissionsUpdateSuccessAction: (state, action) => (0, _fetchHelpers.updateSuccessReducer)(state, action),
    permissionUpdateFailureAction: (state, action) => (0, _fetchHelpers.updateFailureReducer)(state, action)
  },
  initialState
});
const {
  permissionsFetchStartAction,
  permissionsFetchSuccessAction,
  permissionsFetchErrorAction,
  permissionsBatchCreateSuccessAction,
  permissionUpdateStartAction,
  permissionUpdateFailureAction,
  permissionsUpdateSuccessAction
} = issuePermissionsSlice.actions;
const reducer = exports.reducer = issuePermissionsSlice.reducer;
const fetchIssuePermissionsAction = function () {
  let {
    onSuccess = _noop.default
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return async (dispatch, getState, _ref) => {
    let {
      sdk
    } = _ref;
    dispatch(permissionsFetchStartAction());
    try {
      const response = await sdk.IssuePermissions.getAll();
      dispatch(permissionsFetchSuccessAction(response.results));
      onSuccess();
    } catch {
      dispatch(permissionsFetchErrorAction());
    }
  };
};
exports.fetchIssuePermissionsAction = fetchIssuePermissionsAction;
const batchCreateIssuePermissionsAction = _ref2 => {
  let {
    permissions,
    onSuccess = _noop.default,
    onError = _noop.default
  } = _ref2;
  return async (dispatch, getState, _ref3) => {
    let {
      sdk
    } = _ref3;
    try {
      const batchResponse = await sdk.IssuePermissions.batchCreate(permissions);
      dispatch(permissionsBatchCreateSuccessAction(batchResponse));
      onSuccess(batchResponse);
    } catch (e) {
      onError(e);
    }
  };
};
exports.batchCreateIssuePermissionsAction = batchCreateIssuePermissionsAction;
const updateIssuePermissionItemAction = _ref4 => {
  let {
    id,
    permissionLevel,
    onSuccess,
    onFailure
  } = _ref4;
  return async (dispatch, getState, _ref5) => {
    let {
      sdk
    } = _ref5;
    dispatch(permissionUpdateStartAction({
      id,
      permissionLevel
    }));
    try {
      const result = await sdk.IssuePermissions.update(id, {
        permissionLevel
      });
      dispatch(permissionsUpdateSuccessAction(result));
    } catch (error) {
      dispatch(permissionUpdateFailureAction({
        id
      }));
      onFailure && onFailure(error);
      return;
    }
    onSuccess && onSuccess();
  };
};
exports.updateIssuePermissionItemAction = updateIssuePermissionItemAction;
const deleteIssuePermissionAction = _ref6 => {
  let {
    id
  } = _ref6;
  return async (dispatch, getState, _ref7) => {
    let {
      sdk
    } = _ref7;
    await sdk.IssuePermissions.delete(id);
    dispatch(fetchIssuePermissionsAction());
  };
};
exports.deleteIssuePermissionAction = deleteIssuePermissionAction;
const STATE_KEY = exports.STATE_KEY = issuePermissionsSlice.name;
const getIssuePermissionsState = state => state[STATE_KEY];
const getIsLoadingIssuePermissions = exports.getIsLoadingIssuePermissions = (0, _toolkit.createSelector)(getIssuePermissionsState, _fetchHelpers.isLoading);
const getIssuePermissions = exports.getIssuePermissions = (0, _fetchHelpers.createOrderedListSelector)(getIssuePermissionsState);
const getNewPermissionIds = exports.getNewPermissionIds = (0, _toolkit.createSelector)(getIssuePermissionsState, state => state.newEntityIds);
//# sourceMappingURL=issuePermissions.js.map